export class PortalConfig {
  canPrint?: boolean;
  canCheck?: boolean;
  defaultNif?: string;
  convertLang?: boolean;
  requiredFieldsValue?: number;
  type?: string;
}
